module.exports = __webpack_public_path__ + "img/eqHeader2.46a17ed7.png";